import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/appli/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/appli/layouts/login.vue").then(m => m.default || m)),
  public: defineAsyncComponent(() => import("/appli/layouts/public.vue").then(m => m.default || m))
}